import TrackElements from '@capsule/track-elements'

import type { TrackingEntry } from 'shared/assets/types/TrackingEntry'

export default class articleRecommended {
	private recommendedArticles: HTMLElement | null
	private recommendedArticles_articleCard: NodeListOf<HTMLElement> | undefined
	private trackingDataArray: TrackingEntry[]

	constructor() {
		this.recommendedArticles = document.getElementById('recommendedArticles')
		this.recommendedArticles_articleCard = document.querySelectorAll(
			'.recommendedArticles .articleCard'
		)
		this.trackingDataArray = []
	}

	init() {
		this.addEvents()
	}

	/**
	 * Add events
	 * @returns {void}
	 */
	addEvents(): void {
		this.getTrackingDataOnClick()
		this.getTrackingDataOnDisplay()

		const trackElements = new TrackElements(this.trackingDataArray)
		trackElements.init()
	}

	/**
	 * Get tracking data on click
	 * @param carouselListItems
	 * @returns {void}
	 */
	getTrackingDataOnClick() {
		this.recommendedArticles_articleCard &&
			[...this.recommendedArticles_articleCard].forEach((articleCard, index) => {
				const position = index + 1

				this.trackingDataArray.push({
					element: articleCard,
					click: {
						event: 'navigation_click',
						navigation_type: 'related-articles',
						navigation_label: 'carrousel-plongez-dans-le-sujet',
						navigation_name: `article-${position}`
					}
				})
			})
	}

	/**
	 * Get tracking data on display
	 * @returns {void}
	 */
	getTrackingDataOnDisplay(): void {
		this.recommendedArticles &&
			this.trackingDataArray.push({
				element: this.recommendedArticles,
				display: {
					event: 'navigation_display',
					navigation_type: 'related-articles',
					navigation_label: 'carrousel-plongez-dans-le-sujet'
				}
			})
	}
}
